import { registerMutation } from '@adornis/baseql/metadata/register.js';
import { getContactByEmailCOQL } from '@adornis/digitale-helden-shared/api/Contact/getContactByEmail.js';
import { Contact } from '@adornis/digitale-helden-shared/db/Contact.js';
import { LASUser } from '@adornis/digitale-helden-shared/db/las-user.js';
import { getLASUserByEmail } from '@adornis/digitale-helden-shared/features/users/api/getUserByEmail.js';
import { setUserOnContext } from '@adornis/users/server/baseqlContextHelper.js';
import { RegistrationData } from '../../../db/RegistrationData.js';
import { upsertContactAndCheckDOI } from './upsertContactAndCheckDOI.js';

export const registerContact = registerMutation({
  type: () => String,
  operationName: 'registerContact',
  resolve: (instance: RegistrationData, redirectURL?: string) => {
    return async () => {
      const existingContact = await getContactByEmailCOQL(instance.email)({ id: 1 });
      const existingUser = await getLASUserByEmail(instance.email)({ _id: 1 });
      if (existingContact && existingUser) throw new Error('account already registered');

      const contact = new Contact({
        firstName: instance.firstName,
        lastName: instance.lastName,
        email: instance.email,
        hasAcademyAccount: true,
      });

      const upsertedContact = await upsertContactAndCheckDOI(
        contact,
        false,
        undefined,
        redirectURL,
      )({ id: 1, emailStatus: 1 });

      const userID = await LASUser.registerUser({
        username: instance.email,
        email: instance.email,
        password: instance.password,
        additionalFields: { zohoID: upsertedContact.id },
      });

      if (upsertedContact.hasEmailConfirmed()) await setUserOnContext({ _id: userID, _class: LASUser._class });
    };
  },
  params: [
    { name: 'instance', type: () => RegistrationData },
    { name: 'redirectURL', type: () => String },
  ],
});
